<template>
  <div card-item @click="clicked">
    <slot />
  </div>
</template>

<style lang="less">
@import "~@/less/proj";
</style>

<script>

export default {
  name: 'CardItem',
  props: {
    option: Object,
    type: String,
  },
  methods: {
    clicked(e) {
      const target = e.target.parentNode;
      const cardItem = document.querySelectorAll('.scroll .item');
      cardItem.forEach(function (el) {
        el.classList.remove('open');
      })
      target.classList.add('open');
    },
  },
};

</script>
